module.exports = __webpack_public_path__ + "static/media/Decoration_Easter.4370f27e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/decorations/Decoration_Easter.png
// module id = 1345
// module chunks = 3